module.exports = __webpack_public_path__ + "static/media/salad-man.cdc397a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/salad-man.jpg
// module id = 1125
// module chunks = 0